var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotGood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2767_33149)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7896 5.26333C14.5622 5.26333 13.6727 4.82333 13.0696 3.91912C12.9085 3.67596 12.5822 3.61175 12.3401 3.7728C12.098 3.93386 12.0327 4.26017 12.1938 4.50228C12.9959 5.70544 14.2054 6.31596 15.7896 6.31596C16.0801 6.31596 16.3159 6.08017 16.3159 5.78965C16.3159 5.49912 16.0801 5.26333 15.7896 5.26333Z",
    fill: "#E5EAF9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.8057 4.50288C7.96675 4.26078 7.90149 3.93446 7.65938 3.77341C7.41623 3.61236 7.08991 3.67657 6.92991 3.91867C6.32675 4.82393 5.43728 5.26393 4.20991 5.26393C3.91938 5.26393 3.68359 5.49867 3.68359 5.79025C3.68359 6.08078 3.91938 6.31657 4.20991 6.31657C5.79412 6.31657 7.00359 5.70604 7.8057 4.50288Z",
    fill: "#E5EAF9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.636 7.52269C15.4308 7.31743 15.0971 7.31743 14.8918 7.52269L13.1581 9.25532L11.4255 7.52269C11.2202 7.31743 10.8866 7.31743 10.6813 7.52269C10.476 7.72795 10.476 8.06164 10.6813 8.2669L12.4139 10.0006L10.6813 11.7332C10.476 11.9385 10.476 12.2722 10.6813 12.4774C10.8866 12.6827 11.2202 12.6827 11.4255 12.4774L13.1581 10.7448L14.8918 12.4774C15.0971 12.6827 15.4308 12.6827 15.636 12.4774C15.8413 12.2722 15.8413 11.9385 15.636 11.7332L13.9034 10.0006L15.636 8.2669C15.8413 8.06164 15.8413 7.72795 15.636 7.52269Z",
    fill: "#E5EAF9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.57541 12.4775C8.78067 12.6827 9.11436 12.6827 9.31962 12.4775C9.52489 12.2722 9.52489 11.9385 9.31962 11.7332L7.58699 9.99956L9.31962 8.26693C9.52489 8.06167 9.52489 7.72798 9.31962 7.52272C9.11436 7.31746 8.78067 7.31746 8.57541 7.52272L6.84278 9.25535L5.1091 7.52272C4.90383 7.31746 4.57015 7.31746 4.36488 7.52272C4.15962 7.72798 4.15962 8.06167 4.36488 8.26693L6.09752 9.99956L4.36488 11.7332C4.15962 11.9385 4.15962 12.2722 4.36488 12.4775C4.57015 12.6827 4.90383 12.6827 5.1091 12.4775L6.84278 10.7448L8.57541 12.4775Z",
    fill: "#E5EAF9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99877 16.8424C9.14298 16.8424 8.41982 16.3603 8.41982 15.7898C8.41982 15.2193 9.14298 14.7372 9.99877 14.7372C10.8546 14.7372 11.5777 15.2193 11.5777 15.7898C11.5777 16.3603 10.8546 16.8424 9.99877 16.8424ZM9.99877 13.6845C8.54824 13.6845 7.36719 14.6288 7.36719 15.7898C7.36719 16.9509 8.54824 17.8951 9.99877 17.8951C11.4493 17.8951 12.6303 16.9509 12.6303 15.7898C12.6303 14.6288 11.4493 13.6845 9.99877 13.6845Z",
    fill: "#E5EAF9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 18.9475C5.06632 18.9475 1.05263 14.9338 1.05263 10.0001C1.05263 5.06644 5.06632 1.05275 10 1.05275C14.9337 1.05275 18.9474 5.06644 18.9474 10.0001C18.9474 14.9338 14.9337 18.9475 10 18.9475ZM10 0.00012207C4.48632 0.00012207 0 4.48644 0 10.0001C0 15.5138 4.48632 20.0001 10 20.0001C15.5137 20.0001 20 15.5138 20 10.0001C20 4.48644 15.5137 0.00012207 10 0.00012207Z",
    fill: "#E5EAF9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2767_33149"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotGood);
export default __webpack_public_path__ + "static/media/notGood.071d9bca1799f29a392ee2dc00df9665.svg";
export { ForwardRef as ReactComponent };